import { render, staticRenderFns } from "./MbContentReport.vue?vue&type=template&id=d7661ebc&"
import script from "./MbContentReport.vue?vue&type=script&lang=js&"
export * from "./MbContentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports